var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['upload', { 'upload-check': _vm.type === 'check' }]},[_c('el-upload',{class:[
      'upload-pdf',
      { 'no-url': !_vm.fileList.length || !_vm.fileList[0].url }
    ],attrs:{"accept":_vm.acceptType,"action":"/app/file/upload/file","multiple":"","file-list":_vm.fileList,"on-remove":_vm.handleRemove,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.handleBeforeUpload}},[(_vm.type != 'check')?_c('el-button',{attrs:{"size":"mini"}},[_c('i',{staticClass:"e6-icon-upload_fill"}),_vm._v(" 上传文件 ")]):_vm._e(),(_vm.type != 'check')?_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(" "+_vm._s(_vm.getUploadTips())+" ")]):_vm._e()],1),(
      _vm.fileList.length &&
        _vm.fileList[0].url &&
        _vm.fileList[0].name.substring(
          _vm.fileList[0].name.length - 4,
          _vm.fileList[0].name.length
        ) == '.pdf'
    )?_c('el-button',{staticClass:"pre-view",attrs:{"type":"text"},on:{"click":function($event){return _vm.preView(_vm.fileList.length ? _vm.fileList[0].url : [])}}},[_vm._v("点击预览")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }